import { IconButton } from "@mui/material";
import BarChartRounded from "@mui/icons-material/BarChartRounded";
import ChevronLeftRounded from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRounded from "@mui/icons-material/ChevronRightRounded";
import PropTypes from "prop-types";
import "./ReportGraphPanel.css";

const ReportGraphPanel = ({
  eyebrow,
  title,
  description,
  page,
  pageCount,
  pageSize,
  totalCount,
  isLoading,
  onPageChange,
  children,
}) => {
  const firstRecord = totalCount ? page * pageSize + 1 : 0;
  const lastRecord = Math.min((page + 1) * pageSize, totalCount);

  return (
    <section className="report-graph-panel" aria-label={`${title} graph`}>
      <header className="report-graph-panel__header">
        <span className="report-graph-panel__icon">
          <BarChartRounded />
        </span>
        <div className="report-graph-panel__heading">
          <span className="report-graph-panel__eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div className="report-graph-panel__total">
          <strong>{totalCount.toLocaleString()}</strong>
          <span>matching records</span>
        </div>
      </header>

      <div className="report-graph-panel__chart">{children}</div>

      <footer className="report-graph-panel__footer">
        <span>
          Showing {firstRecord.toLocaleString()}–{lastRecord.toLocaleString()} of{" "}
          {totalCount.toLocaleString()}
        </span>
        <div className="report-graph-panel__pagination">
          <span>
            Page {pageCount ? page + 1 : 0} of {pageCount}
          </span>
          <IconButton
            size="small"
            aria-label="Previous graph page"
            disabled={page <= 0 || isLoading}
            onClick={() => onPageChange(page - 1)}
          >
            <ChevronLeftRounded />
          </IconButton>
          <IconButton
            size="small"
            aria-label="Next graph page"
            disabled={pageCount === 0 || page >= pageCount - 1 || isLoading}
            onClick={() => onPageChange(page + 1)}
          >
            <ChevronRightRounded />
          </IconButton>
        </div>
      </footer>
    </section>
  );
};

ReportGraphPanel.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ReportGraphPanel;